import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { environment } from 'src/environments/environment';
import { DemoDataService } from 'src/shared/services/demo-data.service';

export interface PropertyDeposit {
  id: number;
  property_id: number;
  property_name: string;
  guest_name: string;
  reservation_dates: string;
  deposit_type: string;
  amount: number;
  status: string;
  held_date: string;
  release_date: string;
  claim_amount: number;
  claim_reason: string;
  channel: string;
  created_at: string;
  updated_at: string;
}

const DUMMY_DEPOSITS: PropertyDeposit[] = [
  {
    id: 1,
    property_id: 101,
    property_name: 'Beach House',
    guest_name: 'Emily R.',
    reservation_dates: 'Feb 1–5, 2026',
    deposit_type: 'Security Deposit',
    amount: 500,
    status: 'Held',
    held_date: '2026-01-25',
    release_date: '',
    claim_amount: 0,
    claim_reason: '',
    channel: 'Airbnb',
    created_at: '2026-01-25T00:00:00Z',
    updated_at: '2026-01-25T00:00:00Z',
  },
  {
    id: 2,
    property_id: 101,
    property_name: 'Beach House',
    guest_name: 'Marcus T.',
    reservation_dates: 'Jan 20–25, 2026',
    deposit_type: 'Security Deposit',
    amount: 500,
    status: 'Partial Claim',
    held_date: '2026-01-13',
    release_date: '2026-01-28',
    claim_amount: 150,
    claim_reason: 'Bathroom faucet damage',
    channel: 'VRBO',
    created_at: '2026-01-13T00:00:00Z',
    updated_at: '2026-01-28T00:00:00Z',
  },
  {
    id: 3,
    property_id: 102,
    property_name: 'Mountain Cabin',
    guest_name: 'Sarah & Jake L.',
    reservation_dates: 'Jan 28 – Feb 2, 2026',
    deposit_type: 'Security Deposit',
    amount: 400,
    status: 'Refunded',
    held_date: '2026-01-21',
    release_date: '2026-02-05',
    claim_amount: 0,
    claim_reason: '',
    channel: 'Airbnb',
    created_at: '2026-01-21T00:00:00Z',
    updated_at: '2026-02-05T00:00:00Z',
  },
  {
    id: 4,
    property_id: 102,
    property_name: 'Mountain Cabin',
    guest_name: 'Chris D.',
    reservation_dates: 'Feb 10–15, 2026',
    deposit_type: 'Pet Deposit',
    amount: 250,
    status: 'Held',
    held_date: '2026-02-03',
    release_date: '',
    claim_amount: 0,
    claim_reason: '',
    channel: 'Airbnb',
    created_at: '2026-02-03T00:00:00Z',
    updated_at: '2026-02-03T00:00:00Z',
  },
  {
    id: 5,
    property_id: 103,
    property_name: 'City Apartment',
    guest_name: 'Diana K.',
    reservation_dates: 'Feb 10–14, 2026',
    deposit_type: 'Security Deposit',
    amount: 300,
    status: 'Held',
    held_date: '2026-02-03',
    release_date: '',
    claim_amount: 0,
    claim_reason: '',
    channel: 'Booking.com',
    created_at: '2026-02-03T00:00:00Z',
    updated_at: '2026-02-03T00:00:00Z',
  },
  {
    id: 6,
    property_id: 104,
    property_name: 'Lake House',
    guest_name: 'Rebecca N.',
    reservation_dates: 'Jan 5–9, 2026',
    deposit_type: 'Security Deposit',
    amount: 500,
    status: 'Full Claim',
    held_date: '2025-12-29',
    release_date: '2026-01-15',
    claim_amount: 500,
    claim_reason: 'Extensive cleaning required — house not left in acceptable condition',
    channel: 'Direct',
    created_at: '2025-12-29T00:00:00Z',
    updated_at: '2026-01-15T00:00:00Z',
  },
  {
    id: 7,
    property_id: 104,
    property_name: 'Lake House',
    guest_name: 'The Martinez Family',
    reservation_dates: 'Feb 7–12, 2026',
    deposit_type: 'Security Deposit',
    amount: 500,
    status: 'Refunded',
    held_date: '2026-01-31',
    release_date: '2026-02-15',
    claim_amount: 0,
    claim_reason: '',
    channel: 'VRBO',
    created_at: '2026-01-31T00:00:00Z',
    updated_at: '2026-02-15T00:00:00Z',
  },
  {
    id: 8,
    property_id: 104,
    property_name: 'Lake House',
    guest_name: 'The Martinez Family',
    reservation_dates: 'Feb 7–12, 2026',
    deposit_type: 'Pet Deposit',
    amount: 200,
    status: 'Refunded',
    held_date: '2026-01-31',
    release_date: '2026-02-15',
    claim_amount: 0,
    claim_reason: '',
    channel: 'VRBO',
    created_at: '2026-01-31T00:00:00Z',
    updated_at: '2026-02-15T00:00:00Z',
  },
  {
    id: 9,
    property_id: 105,
    property_name: 'Downtown Loft',
    guest_name: 'Alex P.',
    reservation_dates: 'Feb 14–17, 2026',
    deposit_type: 'Security Deposit',
    amount: 350,
    status: 'Held',
    held_date: '2026-02-07',
    release_date: '',
    claim_amount: 0,
    claim_reason: '',
    channel: 'Airbnb',
    created_at: '2026-02-07T00:00:00Z',
    updated_at: '2026-02-07T00:00:00Z',
  },
  {
    id: 10,
    property_id: 105,
    property_name: 'Downtown Loft',
    guest_name: 'Nina S.',
    reservation_dates: 'Jan 8–12, 2026',
    deposit_type: 'Damage Deposit',
    amount: 750,
    status: 'Partial Claim',
    held_date: '2026-01-01',
    release_date: '2026-01-18',
    claim_amount: 320,
    claim_reason: 'Broken kitchen cabinet door and stained sofa cushion',
    channel: 'Airbnb',
    created_at: '2026-01-01T00:00:00Z',
    updated_at: '2026-01-18T00:00:00Z',
  },
];

@Injectable({
  providedIn: 'root'
})
export class PropertyDepositsService {

  private http = inject(HttpClient);
  private demoData = inject(DemoDataService);
  private useDummyData = true;

  // Deposits have no backend yet — the sample deposits belong only to the
  // demo/preview worlds; real accounts must see an empty list.
  private get showsDummyData(): boolean {
    return this.useDummyData && this.demoData.shouldServeTemplates();
  }

  async getPropertyDeposits(): Promise<PropertyDeposit[]> {
    if (this.useDummyData) {
      return this.showsDummyData ? DUMMY_DEPOSITS : [];
    }
    return firstValueFrom(
      this.http.get<PropertyDeposit[]>(`${environment.api_url}api/v1/customer/property-deposits`)
    );
  }

  async createPropertyDeposit(deposit: Partial<PropertyDeposit>): Promise<PropertyDeposit> {
    if (this.useDummyData) {
      const newDeposit: PropertyDeposit = {
        id: DUMMY_DEPOSITS.length + 1,
        property_id: deposit.property_id || 0,
        property_name: deposit.property_name || '',
        guest_name: deposit.guest_name || '',
        reservation_dates: deposit.reservation_dates || '',
        deposit_type: deposit.deposit_type || 'Security Deposit',
        amount: deposit.amount || 0,
        status: deposit.status || 'Held',
        held_date: deposit.held_date || '',
        release_date: deposit.release_date || '',
        claim_amount: deposit.claim_amount || 0,
        claim_reason: deposit.claim_reason || '',
        channel: deposit.channel || '',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      };
      DUMMY_DEPOSITS.push(newDeposit);
      return newDeposit;
    }
    return firstValueFrom(
      this.http.post<PropertyDeposit>(`${environment.api_url}api/v1/customer/property-deposits`, deposit)
    );
  }

  async updatePropertyDeposit(id: number, deposit: Partial<PropertyDeposit>): Promise<PropertyDeposit> {
    if (this.useDummyData) {
      const idx = DUMMY_DEPOSITS.findIndex(d => d.id === id);
      if (idx >= 0) {
        DUMMY_DEPOSITS[idx] = { ...DUMMY_DEPOSITS[idx], ...deposit, updated_at: new Date().toISOString() };
        return DUMMY_DEPOSITS[idx];
      }
      throw new Error('Deposit not found');
    }
    return firstValueFrom(
      this.http.put<PropertyDeposit>(`${environment.api_url}api/v1/customer/property-deposits/${id}`, deposit)
    );
  }

  async deletePropertyDeposit(id: number): Promise<void> {
    if (this.useDummyData) {
      const idx = DUMMY_DEPOSITS.findIndex(d => d.id === id);
      if (idx >= 0) {
        DUMMY_DEPOSITS.splice(idx, 1);
      }
      return;
    }
    return firstValueFrom(
      this.http.delete<void>(`${environment.api_url}api/v1/customer/property-deposits/${id}`)
    );
  }
}
